<template>
  <h1>UI Kit</h1>
  <div class="ui-wrapper">
    <Typo />
    <Colors />
    <Buttons />
    <Forms />
    <Tags />
    <Toast />
    <Pagination />
    <Breadcrumb />
    <Stepper />
    <Modal />
    <Table />
  </div>
</template>

<script setup>
import Breadcrumb from "./BreadcrumbView.vue";
import Buttons from "./ButtonsView.vue";
import Colors from "./ColorsView.vue";
import Forms from "./FormView.vue";
import Modal from "./ModalView.vue";
import Pagination from "./PaginationView.vue";
import Stepper from "./StepperView.vue";
import Table from "./TableView.vue";
import Tags from "./TagsView.vue";
import Toast from "./ToastsView.vue";
import Typo from "./TypographyView.vue";
</script>
